export const MODAL_CONTENT_TYPES = {
  PREVIEW_PROMPT: 'PREVIEW_PROMPT',
};
